(function($){
 $(function(){
   var headerHeight = 60;

   $(window).scroll(function() {
     var scrolled = $(document).scrollTop();
     if (scrolled > headerHeight){
       $('.navbar').addClass('drop-shadow');
     } else {
       $('.navbar').removeClass('drop-shadow');
     }
   });
 });
})(jQuery);